module.exports = __webpack_public_path__ + "img/go-fullscreen.811de106.svg";